import { render, staticRenderFns } from "./RepresentativeDetailsForm.vue?vue&type=template&id=4aac6dc2"
import script from "./RepresentativeDetailsForm.vue?vue&type=script&lang=js"
export * from "./RepresentativeDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports